import React from 'react';
import { Button, Form, Input } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';
import axios from "axios";

const fetchGradingMethods = () => axios.get('/grading-methods');
const fetchExamTypes = () => axios.get('/graded-activity-types');

export default class ExamFilters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gradingMethods: [],
            examTypes: [],

            courseImplementationName: '',
            gradedActivityTypeId:'',
            classroom:'',
            gradedActivityDate:null

        };

        this.getFilterData = this.getFilterData.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount(){
        axios.all([fetchGradingMethods(), fetchExamTypes()])
            .then(axios.spread((gradingMethodRes, examTypeRes) => {
                const gradingMethods = gradingMethodRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));
                const examTypes = examTypeRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));

                this.setState({
                    gradingMethods,
                    examTypes,
                });
            }))
            .catch(err => {
                console.log('Failed to fetch data...');
            });
    }


    getFilterData() {
        if (!this.state.courseImplementationName && !this.state.gradedActivityTypeId
            && !this.state.classroom && !this.state.gradedActivityDate) {
            toast('Morate unijeti po čemu želite filtrirati podatke.');
        } else {
            this.props.getFilterData(
                this.state.courseImplementationName,
                this.state.gradedActivityTypeId,
                this.state.classroom,
                this.state.gradedActivityDate,
            );
        }
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });

    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    render() {
        return (
            <div>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field
                            control={Input}
                            label="Predmet"
                            value={this.state.courseImplementationName}
                            onChange={(e) => this.setState({ courseImplementationName: e.target.value })}
                            name="courseImplementationName"
                            placeholder="Unesite naziv predmeta"
                        />
                        <Form.Field
                            control={Input}
                            label="Prostorija"
                            value={this.state.classroom}
                            onChange={(e) => this.setState({ classroom: e.target.value })}
                            name="classroom"
                            placeholder="Unesite prostoriju"
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        {/*<Form.Field>*/}
                            {/*<label>Način ocjenjivanja</label>*/}
                            {/*<Form.Dropdown clearable*/}
                                {/*selection*/}
                                {/*placeholder="Odaberite način ocjenjivanja"*/}
                                {/*value={this.state.gradingMethodId}*/}
                                {/*onChange={this.handleInputChange}*/}
                                {/*name="gradingMethodId"*/}
                                {/*options={this.state.gradingMethods}*/}
                                {/*search*/}
                                {/*fluid*/}
                            {/*/>*/}
                        {/*</Form.Field>*/}
                        <Form.Field>
                            <label>Tip ispita</label>
                            <Form.Dropdown clearable
                                selection
                                placeholder="Odaberite tip ispita"
                                value={this.state.gradedActivityTypeId}
                                onChange={this.handleInputChange}
                                name="gradedActivityTypeId"
                                options={this.state.examTypes.filter(el => el.id === 2 || el.id === 3)}
                                search
                                fluid
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Datum ispita</label>
                            <DateTimePicker
                                format="D. M. YYYY."
                                defaultValue={null}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'gradedActivityDate')}
                                value={this.state.gradedActivityDate}
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button floated='right' basic="true" color="blue" onClick={this.props.filtersOff}>Odustani
                    </Button>
                    <Button floated='right' color="blue" onClick={this.getFilterData}>Filtriraj
                    </Button>
                </Form>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/ExamFilters.js